import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import performRequest from "../../../api/request.js";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response.js";
import { Toast } from "../../../CustomComponent/toast.js";
import { useSelector } from "react-redux";
import { FcPackage } from "react-icons/fc";
import { BsJournalArrowUp } from "react-icons/bs";

const FarmerInventoryView = () => {
  const [data, setData] = useState(null);
  const [refresh, setRefresh] = useState(false);

  let { id } = useParams();
  const navigate = useNavigate();
  let role = useSelector((store) => store?.login?.user);

  useEffect(() => {
    if (role && role.Role === process.env.REACT_APP_ROLE_CLIENT) {
      if (role.AdditionalRole !== "farmer partner") {
        navigate("/");
      }
    }
  }, [role]);

  useEffect(() => {
    performRequest("GET", `/pmg/fa-inventorys/fa-inventorys/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [id, refresh]);

  return (
    <div className="page-body">
      <div className="container-xxl">
        <div className="page-header d-print-none m-0 p-0">
          <div className="row mb-4">
            <div className="col-md-12">
              <h2 className="page-title">
                <FcPackage className="fs-2  me-1" /> View Farmer Inventory
              </h2>
              <h4 className="text-muted m-0 p-0">Manage your inventory.</h4>
            </div>
            {/* <div className="col-md-8 d-flex justify-content-end">
              <div className="btn-list text-end">
                <div className="d-lg-block d-md-block d-none mt-3 mb-3">
                  <span data-bs-toggle="modal" data-bs-target="#modal-team">
                    <button className="btn btn-primary">
                      <BsJournalArrowUp className="me-2 fs-2" /> Add New Items
                    </button>
                  </span>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        <div className="row g-4">
          {/* PRODUCT CARD */}
          <div className="col-lg-3">
            <div className="card shadow-sm">
              <div
                className="card-body text-start "
                style={{ height: "390px" }}
              >
                <img
                  alt={data?.product?.title}
                  src={data?.product?.image}
                  className="img-fluid rounded"
                  style={{ height: "200px", objectFit: "cover" }}
                />

                <h1 className="mt-3 ">{data?.product?.title}</h1>

                <div className="mt-2">
                  <span className="badge bg-blue-lt me-2">
                    {data?.product?.category}
                  </span>

                  <span className="badge bg-green-lt mt-2">
                    {data?.variants?.[0]?.title}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <h3
                    style={{
                      backgroundColor: "#329537",
                      border: "0.5px solid #084121",
                      borderRadius: "6px",
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: "700",
                      lineHeight: "24px",
                      padding: "3px 9px",
                      textAlign: "center",
                      boxShadow: "1.5px 1.5px 0px #084121",
                      margin: 0,
                      marginTop: 8,
                    }}
                  >
                    ₹{data?.variants?.[0]?.price}
                  </h3>
                </div>
              </div>
            </div>

            {/* USER INFO */}
            {data?.user && (
              <div className="card mt-3 shadow-sm">
                <div className="card-header">
                  <h4 className="card-title">Farmer Info</h4>
                </div>

                <div className="card-body">
                  <p>
                    <b>Name:</b> {data?.user?.userName}
                  </p>

                  <p>
                    <b>Mobile:</b> {data?.user?.contactNumber || "9284636553"}
                  </p>

                  <p>
                    <b>Village:</b>{" "}
                    {data?.user?.residentialAddress ||
                      data?.user?.residentialAddress ||
                      "Wai Maharastra"}
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* PRODUCT DETAILS */}
          <div className="col-lg-9 mb-4">
            <div className="card shadow-sm">
              <div className="card-body">
                <h2 className="mb-3">{data?.product?.title}</h2>

                <p className="text-muted">{data?.product?.body_html}</p>

                <hr />

                {/* VARIANTS TABLE */}
                <h3 className="mb-3">Product Variants</h3>

                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead className="table-light">
                      <tr>
                        <th>Sr</th>
                        <th>Variant</th>
                        <th>SKU</th>
                        <th>Price</th>
                        <th>Total Stock</th>
                      </tr>
                    </thead>

                    <tbody>
                      {data?.variants?.length > 0 ? (
                        data.variants.map((variant, index) => (
                          <tr key={variant.id}>
                            <td>{index + 1}</td>
                            <td className="fs-3" style={{ fontWeight: "bold" }}>
                              {variant.title}
                            </td>
                            <td>{variant.sku || "-"}</td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <span
                                  style={{
                                    backgroundColor: "#329537",
                                    border: "0.5px solid #084121",
                                    borderRadius: "6px",
                                    color: "#fff",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    padding: "3px 9px",
                                    textAlign: "center",
                                    boxShadow: "1.5px 1.5px 0px #084121",
                                    margin: 0,
                                    marginTop: 2,
                                  }}
                                >
                                  ₹{variant.price}
                                </span>
                              </div>
                            </td>
                            <td>
                              <span
                                className="fs-3"
                                style={{ fontWeight: "bold" }}
                              >
                                {variant.quantity} {variant.unit}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No variants found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarmerInventoryView;
